// Module
var code = "<div class=\"eplayer-subtitles\"><p></p></div>\n";
// Exports
export default code;